import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/LoadingSpinner';
import { Message } from 'components/shared';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  customImage: {
    height: "63%",
    width: "63%",
    [theme.breakpoints.down("md")]: {
      height: "100%",
      width: "100%",
    }
  }
}));

function ClusterDiagram({ state }) {
  const { isLoading, isError, error, data } = state;
  const classes = useStyles();


  if (isError) {
    return <Message type="error" text={error} />;
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isLoading && !isError && !data) {
    return <Message type="error" text="No cluster diagram available to display." />;
  }

  return (
    <Box
    display="flex"
    justifyContent="center"
    >

            <Box
            className={classes.customImage}
            component="img"
            src={`data:image/jpeg;base64,${data.img}`}
            alt="cluster-diagram"
            
            />
      </Box>
  );
}


ClusterDiagram.propTypes = {
    state: PropTypes.shape({
      isLoading: PropTypes.bool,
      isError: PropTypes.bool,
      error: PropTypes.string,
      data: PropTypes.shape({})
    }).isRequired,
  };

export default ClusterDiagram;
